import { Component, Input } from '@angular/core';
import { KpiVM } from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-view-model';

@Component({
  selector: 'fl-pilot-kpi-view',
  templateUrl: 'pilot-kpi-stats-view.component.html',
  styleUrls: ['pilot-kpi-stats-view.component.scss'],
})
export class PilotKpiStatsViewComponent {
  @Input()
  public data: KpiVM;
  @Input()
  public displaySize: 'normal' | 'small';
}
